import Service 			from "./../../Libs/Service";
import {Version} from "./Version";
import {Elements} from "./Elements";

let Events = new Service({

	Name: "Events",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},
		"Event Added": function(event) {

			if (event["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					EventAdded: event
				}]);

			}

		},
		"Event Changed": function(event) {

			if (event["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					EventChanged: event
				}]);

			}

		},
		"Event Removed": function(event) {

			if (event["version_id"] === Version.SelectedVersion?.id) {

				Broadcast.call("Send To iFrame", [{
					EventRemoved: event
				}]);

			}

		}
	},

	Actions: {

		//serverId - нода, с которой пришли данные
		"Events": function(events, data, size, serverId) {

			// Получение всех событий креатива или версии
			if (data.EventsCreativeId) this.clearCreativeEvents(data.EventsCreativeId, serverId);
			else if (data.EventsVersionId) this.clearVersionEvents(data.EventsVersionId, serverId);

			this.setEvents(events, !data.EventsCreativeId && !data.EventsVersionId, serverId);

			// Получение всех событий креатива или версии
			if (data.EventsCreativeId) Broadcast.call("Creative Events Loaded", [data.EventsCreativeId]);
			else if (data.EventsVersionId) {
				Broadcast.call("Version Events Loaded", [data.EventsVersionId]);
				if (data.EventsVersionId === Version.SelectedVersion?.id) Broadcast.call("Selected Version Events Loaded", [data.EventsVersionId]);
			}

		},

		"Event": function(event, data, size, serverId) {

			this.setEvent(event, data.EventId, true, serverId);

		},

		"EventActionAdded": function(eventId) {

			Broadcast.call("Event Action Added", [eventId]);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий и событий
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.EventsByServer = {};
		this.EventsByVersionByServer = {};
		this.EventsByHierarchyByServer = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (Events[id]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.Events = this.getServerMap(this.EventsByServer, serverId); // Хэш по id события
		this.EventsByVersion = this.getServerMap(this.EventsByVersionByServer, serverId); // Группировка по id версии -> id события
		this.EventsByHierarchy = this.getServerMap(this.EventsByHierarchyByServer, serverId); // id версии -> экран -> элемент -> событие

	},

	clearCreativeEvents(creativeId, serverId) {

		let events = this.getServerMap(this.EventsByServer, serverId || this.NodeServerId),
			eventsByVersion = this.getServerMap(this.EventsByVersionByServer, serverId || this.NodeServerId),
			eventsByHierarchy = this.getServerMap(this.EventsByHierarchyByServer, serverId || this.NodeServerId);

		_.each(events, event => {

			if (event['creative_id'] === creativeId) {

				delete events[event.id];
				if (eventsByVersion[event['version_id']]) delete eventsByVersion[event['version_id']][event.id];
				if (eventsByHierarchy[event['version_id']]?.[event['screen_codename']]?.[event['element_codename']]?.[event['codename']]) delete eventsByHierarchy[event['version_id']][event['screen_codename']][event['element_codename']][event['codename']];

			}

		});

	},

	clearVersionEvents(versionId, serverId) {

		let events = this.getServerMap(this.EventsByServer, serverId || this.NodeServerId),
			eventsByVersion = this.getServerMap(this.EventsByVersionByServer, serverId || this.NodeServerId),
			eventsByHierarchy = this.getServerMap(this.EventsByHierarchyByServer, serverId || this.NodeServerId);

		_.each(events, event => {

			if (event['version_id'] === versionId) {

				delete events[event.id];
				if (eventsByVersion[event['version_id']]) delete eventsByVersion[event['version_id']][event.id];
				if (eventsByHierarchy[event['version_id']]?.[event['screen_codename']]?.[event['element_codename']]?.[event['codename']]) delete eventsByHierarchy[event['version_id']][event['screen_codename']][event['element_codename']][event['codename']];

			}

		});

	},

	setEvents(events, isBroadcast = true, serverId) {

		_.each(events, event => {

			this.setEvent(event, event.id, isBroadcast, serverId);

		});

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setEvent(event, eventId = null, isBroadcast = true, serverId) {

		serverId = serverId || this.NodeServerId;

		let events = this.getServerMap(this.EventsByServer, serverId),
			eventsByVersion = this.getServerMap(this.EventsByVersionByServer, serverId),
			eventsByHierarchy = this.getServerMap(this.EventsByHierarchyByServer, serverId);

		let oldEvent = events[eventId];

		if (event) {

			events[event.id] = event;

			if (!eventsByVersion[event["version_id"]]) eventsByVersion[event["version_id"]] = {};
			eventsByVersion[event["version_id"]][event.id] = event;

			if (!eventsByHierarchy[event["version_id"]]) eventsByHierarchy[event["version_id"]] = {};
			if (!eventsByHierarchy[event["version_id"]][event["screen_codename"]]) eventsByHierarchy[event["version_id"]][event["screen_codename"]] = {};
			if (!eventsByHierarchy[event["version_id"]][event["screen_codename"]][event["element_codename"]]) eventsByHierarchy[event["version_id"]][event["screen_codename"]][event["element_codename"]] = {};

			eventsByHierarchy[event["version_id"]][event["screen_codename"]][event["element_codename"]][event.codename] = event;

		} else if (oldEvent) {

			delete eventsByVersion[oldEvent["version_id"]][oldEvent.id];
			delete eventsByHierarchy[oldEvent["version_id"]][oldEvent["screen_codename"]][oldEvent["element_codename"]][oldEvent.codename];

		}

		if (isBroadcast) {

			let eventPrefixes = ["Event"];
			// TODO: не хватает глобального доступа к имени выделенного экрана, чтобы однозначно определить меняется ли событие выделенного элемента
			if (oldEvent?.["version_id"] === Version.SelectedVersion?.id && oldEvent?.["element_codename"] === Elements.SelectedElement?.codename) eventPrefixes.push("Selected Element Event"); // Это конечно не совсем точно - но примерно можно определить принадлежность к текущему элементу
			else if (event?.["version_id"] === Version.SelectedVersion?.id && event?.["element_codename"] === Elements.SelectedElement?.codename) eventPrefixes.push("Selected Element Event");
			else if (oldEvent?.["screen_codename"] || event?.["screen_codename"]) eventPrefixes.push("Screen Event");
			else if (!oldEvent?.["screen_codename"] || !event?.["screen_codename"]) eventPrefixes.push("Global Event");

			// Определяем автоматически изменения в объектах и запускаем соответствующие события
			this.broadcastChanges(oldEvent, event, eventPrefixes);

		}

	},

	getVersionEvents(version) {

		return this.EventsByVersion[version.id];

	},

	// Этот метод вероятно должен быть синхронизирован с getTemplateEvents чтобы дашборд правильно понимал есть ли отличия в событиях шаблона и креатива сделанного от этого шаблона
	getEvents(versionId, screenCodename, elementCodename) {

		return _.orderBy(_.filter(_.values(this.EventsByHierarchy[versionId]?.[screenCodename]?.[elementCodename]), event => !event.options.dev && Metadata.EventsByCodename[event.codename]?.active), 'id') || [];

	},

	getTemplateEvents(templateId, screenCodename, elementCodename) {

		return _.orderBy(_.filter(_.values(Metadata.TemplateEventsByHierarchy[templateId]?.[screenCodename]?.[elementCodename]), event => !event.options.dev && Metadata.EventsByCodename[event.codename]?.active), 'id') || [];

	},

	// Этот метод вероятно должен быть синхронизирован с getTemplateScreenEvents чтобы дашборд правильно понимал есть ли отличия в событиях шаблона и креатива сделанного от этого шаблона
	getScreenEvents(versionId, screenCodename) {

		return _.orderBy(_.filter(_.values(this.EventsByHierarchy[versionId]?.[screenCodename]?.['']), event => !event.options.dev && Metadata.EventsByCodename[event.codename]?.active), 'id') || [];

	},

	getTemplateScreenEvents(templateId, screenCodename) {

		return _.orderBy(_.filter(_.values(Metadata.TemplateEventsByHierarchy[templateId]?.[screenCodename]?.['']), event => !event.options.dev && Metadata.EventsByCodename[event.codename]?.active), 'id') || [];

	},

	// Этот метод вероятно должен быть синхронизирован с getTemplateGlobalEvents чтобы дашборд правильно понимал есть ли отличия в событиях шаблона и креатива сделанного от этого шаблона
	getGlobalEvents(versionId) {

		return _.orderBy(_.filter(_.values(this.EventsByHierarchy[versionId]?.['']?.['']), event => !event.options.dev && Metadata.EventsByCodename[event.codename]?.active), 'id') || [];

	},

	getTemplateGlobalEvents(templateId) {

		return _.orderBy(_.filter(_.values(Metadata.TemplateEventsByHierarchy[templateId]?.['']?.['']), event => !event.options.dev && Metadata.EventsByCodename[event.codename]?.active), 'id') || [];

	}

});

window.Events = Events;

export { Events }

